import i18n from '@/plugins/i18n'
import { BuilderGptGetters} from './types'

const getters: BuilderGptGetters = {
    getCurrentStep(state) : number {
        return state.currentStep
    },
    getConfirmedSteps(state) : number[] {
        return state.confirmedSteps
    },
    getAccessibleStep(state) : number {
        return state.accessibleStep
    },
    getApp(state){
        return state.app
    }, 
}
export default getters
